import { skillRepo, vehicleRepo } from "@repositories";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "../contexts/UserProvider";

export function useSkills() {
  const { currentUser } = useUser();
  const { data: skillsAndVehicles, ...query } = useQuery({
    queryKey: ["skills"],
    queryFn: async () => {
      return {
        skills: (await skillRepo.find({ orderBy: { category: "asc" } })) || [],
        vehicles: (await vehicleRepo.find()) || [],
      };
    },
    staleTime: Infinity,
    enabled: !!currentUser?.id,
  });

  return {
    skillsAndVehicles,
    ...query,
  };
}
